export enum Language {
  Fr = 'fr',
  En = 'en',
}
